import { sessionService } from '../../application/SessionService';

interface UseRetrieveUserTokenResponse {
  token?: string;
}

export const useRetrieveUserToken = (): UseRetrieveUserTokenResponse => {
  return {
    token: sessionService.getToken(),
  };
};
